import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastProvider } from './contexts/ToastContext';
import { ActionsCountProvider } from './contexts/ActionsCountContext';
import ProtectedRoute from './components/ProtectedRoute';
import RoleGuard from './components/RoleGuard';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import UnauthorizedPage from './pages/UnauthorizedPage';
import RoosterPage from './pages/coach/RoosterPage';
import LesAanmakenPage from './pages/coach/LesAanmakenPage';
import LesBewerkenPage from './pages/coach/LesBewerkenPage';
import ClientsPage from './pages/coach/ClientsPage';
import ClientDetailPage from './pages/coach/ClientDetailPage';
import FacturenPage from './pages/coach/FacturenPage';
import OpzeggingenPage from './pages/coach/OpzeggingenPage';
import ReceptenPage from './pages/coach/ReceptenPage';
import RecipeFormPage from './pages/coach/RecipeFormPage';
import InstellingenPage from './pages/admin/InstellingenPage';
import AbonnementenPage from './pages/admin/AbonnementenPage';
import FactuurtekstenPage from './pages/admin/FactuurtekstenPage';
import EmailtekstenPage from './pages/admin/EmailtekstenPage';
import CronDashboardPage from './pages/admin/CronDashboardPage';
import GebruikersBeheerPage from './pages/admin/GebruikersBeheerPage';
import ClientRoosterPage from './pages/client/RoosterPage';
import ClientFacturenPage from './pages/client/FacturenPage';
import ClientCreditsPage from './pages/client/ClientCreditsPage';
import ClientLessenPage from './pages/client/ClientLessenPage';
import ClientInstellingenPage from './pages/client/ClientInstellingenPage';
import ClientMijnAbonnementPage from './pages/client/MijnAbonnementPage';
import ClientAfsprakenPage from './pages/client/AfsprakenPage';
import ClientVoedingPage from './pages/client/VoedingPage';
import ClientWeekschemaPage from './pages/client/WeekschemaPage';
import ClientRecipeDetailPage from './pages/client/RecipeDetailPage';
import BroadcastPushPage from './pages/coach/BroadcastPushPage';
import ActiesPage from './pages/coach/ActiesPage';
import CoachAanvragenPage from './pages/coach/CoachAanvragenPage';
import OvereenkomstPage from './pages/OvereenkomstPage';
import BetalingBevestigingPage from './pages/BetalingBevestigingPage';
import AccountVerwijderenPage from './pages/AccountVerwijderenPage';
import ResetWachtwoordPage from './pages/ResetWachtwoordPage';
import HomeRedirect from './components/HomeRedirect';

const COACH_ROLES  = ['superadmin', 'admin_coach', 'coach'];
const ADMIN_ROLES  = ['superadmin', 'admin_coach'];
const CLIENT_ROLES = ['client'];

export default function App() {
  return (
    <ActionsCountProvider>
    <ToastProvider>
      <BrowserRouter>
        <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/geen-toegang" element={<UnauthorizedPage />} />
        <Route path="/overeenkomst/:token" element={<OvereenkomstPage />} />
        <Route path="/betaling-bevestiging/:invoiceId" element={<BetalingBevestigingPage />} />
        {/* Publiek, zonder auth-guard — harde Google Play-eis voor de
            "Account verwijderen"-link in de Play Console. */}
        <Route path="/account-verwijderen" element={<AccountVerwijderenPage />} />
        {/* Publiek, zonder auth-guard — vangt de Supabase wachtwoord-reset-
            recovery-link op (klik in e-mail, geen ingelogde sessie). */}
        <Route path="/reset-wachtwoord" element={<ResetWachtwoordPage />} />

        <Route element={<ProtectedRoute />}>
          {/* Coach routes */}
          <Route element={<RoleGuard allowed={COACH_ROLES} />}>
            <Route element={<Layout />}>
              <Route path="/coach/rooster" element={<RoosterPage />} />
              <Route path="/coach/les/nieuw" element={<LesAanmakenPage />} />
              <Route path="/coach/les/:lessonId/bewerken" element={<LesBewerkenPage />} />
              <Route path="/coach/clients" element={<ClientsPage />} />
              <Route path="/coach/clients/:id" element={<ClientDetailPage />} />
              <Route path="/coach/facturen" element={<FacturenPage />} />
              <Route path="/coach/opzeggingen" element={<OpzeggingenPage />} />
              <Route path="/coach/recepten" element={<ReceptenPage />} />
              <Route path="/coach/recepten/nieuw" element={<RecipeFormPage />} />
              <Route path="/coach/recepten/:id/bewerken" element={<RecipeFormPage />} />
              <Route path="/coach/push" element={<BroadcastPushPage />} />
              <Route path="/coach/aanvragen" element={<CoachAanvragenPage />} />
              <Route path="/coach/acties" element={<ActiesPage />} />
              <Route path="/coach/overeenkomst/opstellen/:clientId" element={<OvereenkomstPage />} />
              <Route path="/instellingen" element={<InstellingenPage />} />
            </Route>
          </Route>

          {/* Admin routes */}
          <Route element={<RoleGuard allowed={ADMIN_ROLES} />}>
            <Route element={<Layout />}>
              <Route path="/instellingen/abonnementen" element={<AbonnementenPage />} />
              <Route path="/instellingen/factuurteksten" element={<FactuurtekstenPage />} />
              <Route path="/instellingen/emailteksten" element={<EmailtekstenPage />} />
              <Route path="/admin/gebruikers" element={<GebruikersBeheerPage />} />
              <Route path="/admin/cron-dashboard" element={<CronDashboardPage />} />
            </Route>
          </Route>

          {/* Client routes */}
          <Route element={<RoleGuard allowed={CLIENT_ROLES} />}>
            <Route element={<Layout />}>
              <Route path="/client/rooster" element={<ClientRoosterPage />} />
              <Route path="/client/voeding" element={<ClientVoedingPage />} />
              <Route path="/client/voeding/weekschema" element={<ClientWeekschemaPage />} />
              <Route path="/client/voeding/recept/:id" element={<ClientRecipeDetailPage />} />
              <Route path="/client/facturen" element={<ClientFacturenPage />} />
              <Route path="/client/credits" element={<ClientCreditsPage />} />
              <Route path="/client/lessen" element={<ClientLessenPage />} />
              <Route path="/client/afspraken" element={<ClientAfsprakenPage />} />
              <Route path="/mijn-abonnement" element={<ClientMijnAbonnementPage />} />
              <Route path="/client/instellingen" element={<ClientInstellingenPage />} />
            </Route>
          </Route>

          <Route path="/" element={<HomeRedirect />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
    </ToastProvider>
    </ActionsCountProvider>
  );
}
